import { useState, useContext } from "react";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import userContext from "./Context";
import "./Deposite.css";

function Deposite() {

  const [value, setValue] = useState("");
  const [message, setMessage] = useState("");

  const { total, setTotal } = useContext(userContext);

  function add(e) {
    e.preventDefault();

    if (!value || Number(value) <= 0) {
      setMessage("Please enter a valid amount");
      return;
    }

    const newTotal = total + Number(value);
    setTotal(newTotal);
    setMessage("Amount Deposited Successfully ✅");
    setValue("");
  }

  return (
    <div className="deposit-bg">
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card className="deposit-card shadow-lg p-4">
          <h2 className="text-center mb-4">Deposit Amount</h2>

          <Form onSubmit={add}>
            <Form.Group className="mb-3">
              <Form.Label>Enter Amount</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter amount"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100 deposit-btn">
              Deposit
            </Button>
          </Form>

          {message && (
            <Alert variant="success" className="mt-3 text-center">
              {message}
            </Alert>
          )}

          <h4 className="text-center mt-4 total-text">
            Total Balance: ₹ {total}
          </h4>
        </Card>
      </Container>
    </div>
  );
}

export default Deposite;


